import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

export function useReadonly(readonlyProp: MaybeRefOrGetter<boolean>) {
	const isReadonly = computed(() => toValue(readonlyProp));

	function preventKeyboardNavigation(event: KeyboardEvent, allowedKeys: string[] = ['Tab']) {
		if (isReadonly.value && !allowedKeys.includes(event.key)) {
			event.preventDefault();
			event.stopPropagation();
			return true;
		}

		return false;
	}

	function preventPointer(event: Event) {
		if (!isReadonly.value) return false;
		event.preventDefault();
		event.stopPropagation();
		return true;
	}

	return {
		preventKeyboardNavigation,
		preventPointer,
	};
}
